export const getDepartureName = (departure = {}) => {
  return (departure.tourName && departure.variantName)
    ? `${departure.tourName} - ${departure.variantName}`
    : departure.name
}

export const getTourName = (departure = {}) => departure.tourName || departure.name
